module.exports = __webpack_public_path__ + "static/media/1014841.cd563b43.jpg";